import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { ObjectHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/ObjectHelper";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandProcessDuplicatePropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandProcessDuplicateProperties = {
    [name in keyof EntityCommandProcessDuplicatePropertyValues]: Property<EntityCommandProcessDuplicatePropertyValues[name]>
};

export interface IEntityCommandProcessDuplicate extends IEntityCommand, EntityCommandProcessDuplicateProperties
{
}

export class EntityCommandProcessDuplicate extends EntityCommand implements IEntityCommandProcessDuplicate
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandProcessDuplicate";
    public static override className = "EntityCommandProcessDuplicate";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandProcessDuplicatePropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Duplicate",
                entityName: "Process",
                key: "DUPLICATE",
                permission: (PermissionEvaluator.permissionLevels.create ?? 0) | (PermissionEvaluator.permissionLevels.read ?? 0),
                type: EntityCommandTypeEnum.entity,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandProcessDuplicatePropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    const
                        recordId = entityCommandInformation.getRecordId();

                    if (!recordId)
                        return;

                    return (
                        ServiceManager.getRequired(WebApiClientService)
                            .createApiMethodRequest("DataService", "CallDataService", { id: "b185975f-0e14-4944-b706-6353f0d67dc4", operation: "DuplicateProcess", data: ObjectHelper.toJson({ processId: recordId }) })
                            .executeAsync()
                    );
                })
        );
    }

    // #endregion

    // #endregion
    }

